// eslint-disable-next-line no-restricted-imports
import { zodResolver } from "@hookform/resolvers/zod";
import {
  useForm,
  type FieldValues,
  type UseFormProps,
  type UseFormReturn,
} from "react-hook-form";
import type { z } from "zod";

/**
 * A typed wrapper around useForm that uses zodResolver.
 * Breaks the TypeScript inference chain that causes TS2589
 * "Type instantiation is excessively deep" errors with complex Zod schemas.
 */
export function useZodForm<TFormValues extends FieldValues>(
  schema: z.ZodType,
  options?: Omit<UseFormProps<TFormValues>, "resolver">,
): UseFormReturn<TFormValues> {
  "use no memo";
  const zodResolverFn = zodResolver as (...args: unknown[]) => unknown;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const resolver = zodResolverFn(schema) as any;
  return useForm<TFormValues>({ ...options, resolver });
}
